import "./Layout.scss";
import "../App.scss";
import StartingScreen from "./StartingScreen";
import ProgressBar from "./ProgressBar";
import GameScreen from "./GameScreen";
import EndingScreen from "./EndingScreen";

function Layout(props) {
  return (
    <>
      <div className="layout">
        {/* <img
          className={`background__lights background__lights_bottom  ${
            !props.robotAnswerStatus && "background__lights_bottom_above"
          }`}
          src={"../assets/lights/lightsBottom.png"}
          alt="Bottom Lights"
        ></img>*/}
        <ProgressBar
          endingScreen={props.endingScreen}
          questProgress={props.questProgress}
        />
        <div className="layout__card">
          {props.startingScreen && (
            <StartingScreen onStartGame={props.onStartGame} />
          )}
          {!props.endingScreen && !props.startingScreen && (
            <GameScreen
              currentQuest={props.currentQuest}
              previousQuest={props.previousQuest}
              questProgress={props.questProgress}
              slideScoreStatus={props.slideScoreStatus}
              endingScreen={props.endingScreen}
              robotAnswerStatus={props.robotAnswerStatus}
              onRobotAnswerSkip={props.onRobotAnswerSkip}
              onClickA={props.onClickA}
              onClickB={props.onClickB}
            />
          )}
          {props.endingScreen && (
            <EndingScreen
              previousQuest={props.previousQuest}
              currentQuest={props.currentQuest}
              questProgress={props.questProgress}
              endingScreen={props.endingScreen}
              onPlayAgain={props.onPlayAgain}
            />
          )}
        </div>
        <div className="layout__footer">
          {!props.endingScreen && (
            <img
              className="layout__2077"
              src={"../assets/footerBar2077.png"}
              alt="Footer Bar 2077"
            ></img>
          )}
          <img
            className="layout__footer_bar"
            src={"../assets/footerBar.png"}
            alt="Footer Bar"
          ></img>
          {props.endingScreen && (
            <p className="layout_disclaimer">
              Дисклеймер - ООО УК «Альфа-Капитал»:
              <br />
              www.alfacapital.ru 8 (800) 200-28-28
            </p>
          )}
        </div>
      </div>
    </>
  );
}

export default Layout;
